function openTryOnModal() {
  document.getElementById("tryOnModal").classList.remove("hidden");
  document.body.classList.add("modal-open");
}

function closeTryOnModal() {
  document.getElementById("tryOnModal").classList.add("hidden");
  document.body.classList.remove("modal-open");
}

document.addEventListener("DOMContentLoaded", () => {
  const input = document.getElementById("roomImageInput");
  const roomPreview = document.getElementById("roomPreview");
  const paintingOverlay = document.getElementById("paintingOverlay");
  const resizeRange = document.getElementById("resizeRange");

  if (!input || !paintingOverlay) return;

  // Upload image
  input.addEventListener("change", e => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = ev => {
      roomPreview.src = ev.target.result;
      roomPreview.style.display = "block";
      paintingOverlay.style.display = "block";
      paintingOverlay.style.top = "50%";
      paintingOverlay.style.left = "50%";
      paintingOverlay.style.transform = "translate(-50%, -50%)";
    };
    reader.readAsDataURL(file);
  });

  // Dragging
  let isDragging = false, offsetX, offsetY;
  paintingOverlay.addEventListener("mousedown", startDrag);
  paintingOverlay.addEventListener("touchstart", startDrag);

  document.addEventListener("mousemove", drag);
  document.addEventListener("touchmove", drag, { passive: false });

  document.addEventListener("mouseup", stopDrag);
  document.addEventListener("touchend", stopDrag);

  function startDrag(e) {
    isDragging = true;
    const rect = paintingOverlay.getBoundingClientRect();
    offsetX = (e.clientX || e.touches[0].clientX) - rect.left;
    offsetY = (e.clientY || e.touches[0].clientY) - rect.top;
    paintingOverlay.style.transition = "none";
  }

  function drag(e) {
    if (!isDragging) return;
    e.preventDefault();
    const preview = document.querySelector(".tryon-preview-frame");
    const previewRect = preview.getBoundingClientRect();
    const overlayRect = paintingOverlay.getBoundingClientRect();

    const x = (e.clientX || e.touches[0].clientX) - previewRect.left - offsetX;
    const y = (e.clientY || e.touches[0].clientY) - previewRect.top - offsetY;

    const maxX = previewRect.width - overlayRect.width;
    const maxY = previewRect.height - overlayRect.height;

    paintingOverlay.style.left = Math.max(0, Math.min(x, maxX)) + "px";
    paintingOverlay.style.top = Math.max(0, Math.min(y, maxY)) + "px";
    paintingOverlay.style.transform = "none";
  }

  function stopDrag() {
    isDragging = false;
    paintingOverlay.style.transition = "transform 0.25s ease, filter 0.4s ease";
  }

  // Resize via slider
  resizeRange.addEventListener("input", () => {
    paintingOverlay.style.width = `${resizeRange.value}%`;
  });

  // ✅ Smooth & controlled pinch zoom (updated)
  let initialDistance = 0;
  let lastWidth = 35;
  paintingOverlay.addEventListener("touchstart", e => {
    if (e.touches.length === 2) {
      initialDistance = Math.hypot(
        e.touches[0].clientX - e.touches[1].clientX,
        e.touches[0].clientY - e.touches[1].clientY
      );
      lastWidth = parseFloat(paintingOverlay.style.width) || 35;
    }
  });

  paintingOverlay.addEventListener("touchmove", e => {
    if (e.touches.length === 2) {
      e.preventDefault();
      const newDistance = Math.hypot(
        e.touches[0].clientX - e.touches[1].clientX,
        e.touches[0].clientY - e.touches[1].clientY
      );
      if (!initialDistance) return;

      // Smooth scaling factor
      const scale = 1 + (newDistance - initialDistance) / 400;
      const newWidth = Math.min(100, Math.max(20, lastWidth * scale));

      paintingOverlay.style.transition = "width 0.1s ease";
      paintingOverlay.style.width = newWidth + "%";
    }
  });

  paintingOverlay.addEventListener("touchend", () => {
    initialDistance = 0;
  });
});
